export const appName = 'Ops Hub';